import Clarity from '@microsoft/clarity'
import { useEffect } from 'react'

import { securityApi } from 'hooks/api/security'

const CLARITY_PROJECT_ID = process.env.REACT_APP_CLARITY_PROJECT_ID || ''

export default function ClarityProvider() {
  useEffect(() => {
    if (!CLARITY_PROJECT_ID) return
    Clarity.init(CLARITY_PROJECT_ID)

    securityApi()
      .getMe()
      .then((res) => {
        const securityId = String(res.data.id)
        Clarity.identify(securityId)
        Clarity.setTag('kumocan_security_id', securityId)
      })
      .catch(() => {
        // ログイン前など、getMe が失敗するケースは無視
      })
  }, [])

  return null
}
